var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_1005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.334 14.9999H25.1673M16.0007 6.66659V5.83325M16.0007 24.1666V23.3333M22.6673 21.6666L21.834 20.8333M22.6673 8.33325L21.834 9.16659M9.33398 21.6666L10.1673 20.8333M9.33398 8.33325L10.1673 9.16659M6.83398 14.9999H7.66732M16.0007 19.9999C17.3267 19.9999 18.5985 19.4731 19.5362 18.5355C20.4739 17.5978 21.0007 16.326 21.0007 14.9999C21.0007 13.6738 20.4739 12.4021 19.5362 11.4644C18.5985 10.5267 17.3267 9.99992 16.0007 9.99992C14.6746 9.99992 13.4028 10.5267 12.4651 11.4644C11.5274 12.4021 11.0007 13.6738 11.0007 14.9999C11.0007 16.326 11.5274 17.5978 12.4651 18.5355C13.4028 19.4731 14.6746 19.9999 16.0007 19.9999Z",
    stroke: "#FFFF00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_1005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode1);
export default __webpack_public_path__ + "static/media/darkMode1.c1765ab80fb121f5ec34741a7a06ab05.svg";
export { ForwardRef as ReactComponent };